/* eslint-disable indent */

import * as Yup from 'yup';
import { translate } from '@cashfree-intl/coherent';

export const CODSchema = Yup.object().shape({
  COD_ORDER_MINIMUM_AMOUNT: Yup.number().min(
    0,
    `${translate('min_order_amount_must_be_greater_than_0')}`,
  ),
  COD_ORDER_MAXIMUM_AMOUNT: Yup.number()
    .min(0, `${translate('max_order_amount_must_be_greater_than_0')}`)
    .when('COD_ORDER_MINIMUM_AMOUNT', (COD_ORDER_MINIMUM_AMOUNT, schema) =>
      COD_ORDER_MINIMUM_AMOUNT !== undefined
        ? schema.min(
            COD_ORDER_MINIMUM_AMOUNT,
            `${translate(
              'max_order_amount_must_be_greater_than_equal_to_min_amount',
            )}`,
          )
        : schema,
    ),
  COD_HANDLING_CHARGES: Yup.number().min(
    0,
    `${translate('cod_handeling_fee_must_be_greater_than_0')}`,
  ),
});
